<template>
  <div class="root">
    <div class="column">
      <div class="column_header">Всего проектов:</div>
      <div class="column_value">{{ projectCount }}</div>
    </div>
    <div class="column">
      <div class="column_header">Всего УДК:</div>
      <div class="column_value">{{ udcCount }}</div>
    </div>
  </div>
</template>

<script setup>
  import { onMounted, ref, watch } from 'vue';
  import { useApi } from '@/api/use-api';
  import { useRoute } from 'vue-router';

  const props = defineProps({
    topUdcId: Number,
  });

  const api = useApi();
  const route = useRoute();
  const projectCount = ref(null);
  const udcCount = ref(null);

  onMounted(async () => {
    await getPortfolioCounts();
  });

  watch(
    () => props.topUdcId,
    async () => {
      await getPortfolioCounts();
    }
  );

  const getPortfolioCounts = async () => {
    const params = new URLSearchParams({
      briefcaseId: route.params.id,
    });

    if (props.topUdcId) {
      params.append('topUdcId', props.topUdcId.toString());
    }

    try {
      const response = await api.briefcaseUdc.projectUdcCount(params);
      projectCount.value = response.counters.projectCount;
      udcCount.value = response.counters.udcCount;
    } catch (error) {
      console.error('error', error);
    }
  };
</script>

<style scoped lang="scss">
@use "@/assets/styles/_colors.scss" as *;

  .root {
    flex-direction: row;
    display: flex;
    font-family: Nunito Sans, sans-serif;
    height: 102px;

    .column {
      flex-direction: column;
      display: flex;
      width: 129px;
      margin-right: 35px;

      &_header {
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
      }

      &_value {
        color: $color-table-text-secondary;
        font-weight: 600;
        font-size: 62px;
        line-height: 20px;
        margin: auto 0;
      }
    }
  }
</style>
